import moment from 'moment';

export function getAge(dateOfBirth: string): string {
  const birthDate = moment(dateOfBirth);
  const age = moment().diff(birthDate, 'years');
  const ageLabel = age === 1 ? ' year old' : ' years old';
  return age.toString() + ageLabel;
}

export function calculateRelativeRoughAge(epoch: number): string {
  // get the scale of the age, minutes, hours, days, weeks or months
  const secondsDiff = Math.round((Date.now() - epoch) / 1000);
  if (secondsDiff < 60) {
    return `${secondsDiff} second${secondsDiff > 1 ? 's' : ''} ago`;
  } else if (secondsDiff >= 60 && secondsDiff < 3600) {
    const mins = Math.round(secondsDiff / 60);
    return `${mins} minute${mins > 1 ? 's' : ''} ago`;
  } else if (secondsDiff >= 3600 && secondsDiff < 86400) {
    const hours = Math.round(secondsDiff / 3600);
    return `${hours} hour${hours > 1 ? 's' : ''} ago`;
  } else if (secondsDiff >= 86400 && secondsDiff < 604800) {
    const days = Math.round(secondsDiff / 86400);
    return `${days} day${days > 1 ? 's' : ''} ago`;
  } else if (secondsDiff >= 604800 && secondsDiff < 2419200) {
    const weeks = Math.round(secondsDiff / 604800);
    return `${weeks} week${weeks > 1 ? 's' : ''} ago`;
  } else if (secondsDiff >= 2419200) {
    const months = Math.round(secondsDiff / 2419200);
    return `${months} month${months > 1 ? 's' : ''} ago`;
  }
}
